import React from 'react';
// import PropTypes from 'prop-types';

// NotFound.propTypes = {
    
// };

function NotFound(props) {
    return (
        <div>
            Oops ... Not found
        </div>
    );
}

export default NotFound;